<template>
    <div>
        <v-row class="text-center">
            <v-col>
                <h2>Danke für die Registrierung</h2>
                <p>Das hat ja schon gut geklappt! Eine Bitte noch: Wähle bitte den Namen deines Kindes aus der folgenden Liste aus, damit wir alles korrekt zuordnen können :)</p>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-autocomplete label="Name"
                                item-text="name"
                                item-value="id"
                                v-model="id"
                                :items="users"/>
            </v-col>
        </v-row>
        <v-row class="text-center">
            <v-col>
                <v-btn
                    class="mx-2"
                    fab
                    dark
                    large
                    color="cyan"
                    :loading="isSaving"
                    @click="save"
                >
                    <v-icon large>
                        mdi-content-save
                    </v-icon>
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import UserService from "@/services/UserService";

export default {
    data() {
        return {
            users: [],
            id: null,
            isSaving: false
        }
    },
    methods: {
        async getUsers() {
            this.users = await UserService.getPlanUsers(true)
        },
        async save() {
            this.isSaving = true
            const planUserName = await UserService.linkPlanUser(this.$store.getters.getUser.id, this.id)
            const planUser = {
                name: planUserName,
                puid: this.id
            }
            this.$store.dispatch('addPlanUser', { planUser });
            this.isSaving = false
            this.$router.push('/mealplan')
        }
    },
    created() {
        this.getUsers()
    }
}
</script>
